import HTTP from "@/_helpers/http";
import { TRANSACTIONS__API } from "@/_helpers/urls";
import { TRANSACTIONS__MUTATIONS } from "../mutation-types";
import { TRANSACTIONS__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
  deposits: [],
  dashboarddeposists: [],
  totalCount: 0,
  paymentMethods: [],
  isLoading: false,
  isDashboardDepositLoading: false,
  totalDeposits: 0,
  totalDepositCount: 0,
  range: null,
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1
  }
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [TRANSACTIONS__MUTATIONS.TRXDEPOSITS](state, data) {
    state.deposits = data?.data?.summaries
    state.totalCount = data?.data?.summaries?.length;
    state.paymentMethods = data?.data?.paymentMethods;
    state.totalDeposits = data?.data?.totalDeposits;
    state.pagination = data?.data?.pagination;
    state.totalDepositCount = data?.data?.pagination?.total;
    state.range = data?.data?.range || null;
  },
  [TRANSACTIONS__MUTATIONS.TRXDASHBOARDDEPOSITS](state, data) {
    state.dashboarddeposists = data?.data;
    state.totalDepositCount = data?.totalCount;
  },
  SET_LOADING(state, data) {
    state.isLoading = data;
  },
  SET_ISDASH_DEPOSIT_LOADING(state, data) {
    state.isDashboardDepositLoading = data;
  },
};

// Actions
const actions = {
  async [TRANSACTIONS__ACTIONS.TRXDEPOSITS]({ commit, state }, parameter = {}) {
    try {
      commit("SET_LOADING", true);

      const {
        method_name,
        duration,
        status,
        page = 1,
        limit = 10,
        search = ""
      } = parameter;

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(method_name && { method_name }),
        ...(duration && { duration }),
        ...(status && { status }),
        ...(search && { search })
      }).toString();

      const response = await HTTP().get(
        `${TRANSACTIONS__API.TRXDEPOSITS}${queryParams ? `?${queryParams}` : ''}`
      );

      commit(TRANSACTIONS__MUTATIONS.TRXDEPOSITS, response.data);
      commit("SET_LOADING", false);
    } catch (error) {
      console.log(error);
    }
  },

  async [TRANSACTIONS__ACTIONS.TRXDASHBOARDDEPOSITS](
    { commit, state }
  ) {
    try {
      commit("SET_ISDASH_DEPOSIT_LOADING", true);

      const response = await HTTP().get(
        TRANSACTIONS__API.TRXDASHBOARDDEPOSITS
      );

      commit(TRANSACTIONS__MUTATIONS.TRXDASHBOARDDEPOSITS, response.data);
      commit("SET_ISDASH_DEPOSIT_LOADING", false);
    } catch (error) {
      console.log(error);
    }
  },

  async [TRANSACTIONS__ACTIONS.UPDATEDEPOSIT](
    { state, commit, dispatch },
    parameter
  ) {
    try {
      const response = await HTTP().patch(
        TRANSACTIONS__API.UPDATEDEPOSIT,
        parameter
      );
      await dispatch(TRANSACTIONS__ACTIONS.TRXDEPOSITS);
      await dispatch(TRANSACTIONS__ACTIONS.TRXDASHBOARDDEPOSITS);
      toast.success(response.data.message);
    } catch (error) {
      console.error(error);
    }
  },

  async [TRANSACTIONS__ACTIONS.TRXDEPOSITEXCEL]({ commit }, parameter = {}) {
  try {
    commit("SET_LOADING", true);

    const {
      trading_account_type_id,
      duration,
      page = 1,
      limit = -1,          // <-- IMPORTANT: for export ALL
      search = ""
    } = parameter;

    const queryParams = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      ...(trading_account_type_id && { trading_account_type_id }),
      ...(duration && { duration }),
      ...(search && { search })
    }).toString();

    const response = await HTTP().get(
      `${TRANSACTIONS__API.TRXDEPOSITEXCEL}${queryParams ? `?${queryParams}` : ''}`,
      { responseType: "blob" }  // important for file download
    );

    // Download file
    const blob = new Blob([response.data], { type: "application/vnd.ms-excel" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "trx-deposits.xlsx";
    link.click();

    commit("SET_LOADING", false);
  } catch (error) {
    console.error(error);
    commit("SET_LOADING", false);
  }
},

};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
